import { createSelector } from 'reselect';
export const tripInformationSelector = (state: ReduxState) => state?.tripInformation || {};

const tripCriteriaSelector = ({ tripCriteria }) => tripCriteria || {};

const getAdults = createSelector(tripInformationSelector, ({ adults }) => adults || []);
const getAdultsNumber: (state: ReduxState) => number = createSelector(
  tripInformationSelector,
  ({ adults }) => (adults || []).length,
);
const getKids = createSelector(tripInformationSelector, ({ kids }) => kids || []);
const getMainContactOptins = createSelector(tripCriteriaSelector, ({ mainContact }) => mainContact);
export { getAdults, getAdultsNumber, getKids, getMainContactOptins };
